<template>
  <div class="snackbar-wrapper">
    <!-- Snackbar starts -->
    <v-snackbar
      top
      centered
      multi-line
      content-class="py-3"
      v-model="showSnackbar"
      :color="config.bgColor"
      :timeout="$appConfig.snackbar.timeout"
    >
      <!-- Snackbar content to be displayed here -->
      <div class="my-2 mx-2 snackbar-content d-flex">
        <v-icon class="mr-3 align-baseline" :color="config.iconColor">
          {{ config.icon }}
        </v-icon>
        <slot :config="{ ...config }"></slot>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          plain
          :color="config.bgColor"
          v-bind="attrs"
          @click="closeSnackbar(!snackbarValue)"
        >
          <tooltip #default="{on,attrs}" name="Close">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="closeBtnConfig.iconColor"
              class="ml-auto cursor-pointer text--secondary"
            >
              {{ closeBtnConfig.icon }}
            </v-icon>
          </tooltip>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Snackbar Ends -->
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";

/**
 * Displays snackbar and dynamic message on the basis of the props
 */
export default {
  name: "Snackbar",
  /**
   * Custom events to be emitted by the component
   */
  emits: ["close"],
  /**
   * -------------- Components -------------
   */
  components: {
    Tooltip,
  },
  /**
   * -------------- Props -------------
   */
  props: {
    /**
     * Value of the snackbar
     * @model
     */
    snackbarValue: {
      type: Boolean,
      default: false,
    },
    /**
     * Type of snackbar to be displayed
     *  @values success, error, info
     */
    snackBarType: {
      type: String,
      required: true,
    },
  },
  // ------------- Computed properties  -------------
  computed: {
    /**
     * Snackbar types
     * @type {Objec}
     */
    snackbarTypes() {
      const { snackbarTypes } = this.$appConfig.snackbar;
      return snackbarTypes;
    },
    /**
     * Close snackbar button config
     */
    closeBtnConfig() {
      return this.$appConfig.snackbar.config.close;
    },
    /**
     * The value for snackbar
     * @description the value gets calculated on the basis of the {snackbarValue} props
     * @type {Boolean}
     * @model snackbar v-model
     */
    showSnackbar: {
      get() {
        return this.snackbarValue;
      },
      set(val) {
        this.closeSnackbar(val);
      },
    },
    /**
     * Snackbar configuration settings
     * @values success, error, info - These 3 snackbar types are supported to show the messages to the users
     * @type {String}
     */
    config() {
      const { success, info, error } = this.$appConfig.snackbar.config;

      switch (this.snackBarType) {
        default:
        case this.snackbarTypes.info:
          return info;

        case this.snackbarTypes.success:
          return success;

        case this.snackbarTypes.error:
          return error;
      }
    },
  },
  methods: {
    /**
     * Emits an custom event in the parent component to close the snackbar
     * @param {Boolean} val - new value of the snackbar
     * @description gets called when the user clicks the close button in snackbar
     * @emits close
     */
    closeSnackbar(val) {
      this.$emit("close", val);
    },
  },
};
</script>
